import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import TaskFormView from 'components/Task/TaskFormView';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import useActions from './utils/useActions';

export default function TaskFormViewContainer() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { getUserAccessByCompany }: ContextProps = useOutletContext();
  const isViewLocked =
    getUserAccessByCompany(AccessComponentEnum.DocumentationManagement) ===
    AccessLevelEnum.LimitedRead;

  const {
    idParam,
    onOpenEditTaskDetails,
    refetchTaskFormTemplate,
    taskData,
    taskFormTemplate,
    taskFormTemplateError,
    taskFormTemplateLoading,
    taskFormTemplateVersion,
  } = useActions({ isViewLocked });

  return (
    <>
      <BreadCrumbs
        data={getBreadCrumbsDataByKey({
          pathname,
          t,
          entity: { id: taskData?.id, name: taskData?.name },
        })}
      />
      <TaskFormView
        idParam={idParam}
        onOpenEditTaskDetails={onOpenEditTaskDetails}
        refetchTaskFormTemplate={refetchTaskFormTemplate}
        taskData={taskData}
        taskFormTemplate={taskFormTemplate}
        taskFormTemplateVersion={taskFormTemplateVersion}
        taskFormTemplateGraphQLErrors={taskFormTemplateError}
        taskFormTemplateLoading={taskFormTemplateLoading}
      />
    </>
  );
}
